import {useDialog} from '@hooks';

export const useDestructiveDialog = () => {
  const {destructiveDialog} = useDialog();

  return {destructiveDialog};
};
